import {
  CLEAR_ORDER,
  CREATE_ORDER,
  FETCH_ORDERS,
  DELETE_ORDER,
} from '../types';

export const orderReducers = (state = {}, action) => {
  switch (action.type) {
    case CREATE_ORDER:
      return { ...state, order: action.payload };
    case CLEAR_ORDER:
      return { ...state, order: null };
    case FETCH_ORDERS:
      return { ...state, items: action.payload };
    case DELETE_ORDER:
      return { ...state, items: action.payload };

    default:
      return state;
  }
};
